import { da as da$1 } from 'date-fns/locale';
import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var da = {
  language: 'da',
  country: 'dk',
  name: 'Dansk',
  embeddedLocale: merge(error, login),
  flags: ['DK'],
  dateFns: da$1,
  format: {
    date: 'd.MM.yyyy',
    dateTime: '$t(format:date) $t(format:time)',
    time: 'HH:mm',
  },
};

export { da as default };
